import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import cn from 'classnames';

const defaultMessage = 'NO MESSAGE';
export function LibraryNotice({ id, className }) {
  const intl = useIntl();
  const notice = intl.formatMessage({ id, defaultMessage });

  return (
    notice !== defaultMessage && (
      <div className={cn('cp-library-notice', className)}>
        <FormattedHTMLMessage id={id} />
      </div>
    )
  );
}

LibraryNotice.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default LibraryNotice;
